<template>
  <div class="survey-point text-center" v-if="!answerPoint.pending">
    <template v-if="!hasUser">
      <div @click="onPoint">
        <img src="~@/assets/img/point-btn.png" alt="" width="343" />
      </div>
    </template>
    <template v-else>
      <split-box bg-color="#FFE4CC" line-color="rgba(0,0,0,0.15)" v-if="answerPoint.value && answerPoint.value.point">
        <template v-slot:top-content>
          <div>
            <span>恭喜您抽中积分</span>
            <span v-if="enableNetManualAudit">，积分将在问卷发布者审核通过后发放</span>
          </div>
          <div class="mt-2">
            <span class="font-bold text-danger" style="color: #FF7700;font-size: 36px;">{{ surveyPoint.point }}</span>
            <span class="text-medium font-semibold" style="color: #FF7700;"> 积分</span>
          </div>
          <div class="point-btn" @click="toPoint">
            积分兑好礼
          </div>
        </template>
        <template v-slot:bottom-content>
          <div class=" text-theme-black-450">
            <template v-if="enableNetManualAudit">
              问卷将在 {{ auditForRedEnvelopesAutoPassTime }} 小时内审核，审核通过后，积分将发放至<span
                class="text-theme"
                @click="onToMiniProgram"
                > 调研工厂账户 </span
              >~</template
            >
            <template v-else>
              积分已发放至 <span class="text-theme" @click="onToMiniProgram"> 调研工厂账户 </span>，请查收~</template
            >
          </div>
        </template>
      </split-box>
      <template v-else>
        <div class="bg-white p-4 shadow-theme rounded-small mt-4">
          <div class="text-small text-theme-black-450 text-center leading-18">
            <div>
              <img src="~@/assets/img/answer/point.png" alt="" width="132" />
            </div>
            <template v-if="!allowAwardWithoutFollow">
              <p>真遗憾，积分与您擦肩而过</p>
            </template>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import SplitBox from '@/components/SplitBox'
import { createPopup } from '@/assets/js/factory'
import ReceiveReward from '@/components/overlay/ReceiveReward'
import { Dialog } from 'vant'
import { getMiniProgramScheme } from 'dygc'

export default {
  name: 'SurveyPoint',
  components: { SplitBox },
  computed: {
    hasUser() {
      return !!this.$bus.params.accountUserId
    },
    enableNetManualAudit() {
      const enableAuditForRedEnvelopes = this.$bus.survey.otherSetting.enableAuditForRedEnvelopes
      return this.$bus.enableNetManualAudit && !enableAuditForRedEnvelopes
    },
    answerPoint() {
      return this.$bus.answerPoint
    },
    surveyPoint() {
      return this.$bus.surveyPoint
    },
    from() {
      console.log('from',this.$bus.params.from)
      return this.$bus.params.from
    },
    allowAwardWithoutFollow() {
      return this.overData?.allowAwardWithoutFollow
    },
    auditForRedEnvelopesAutoPassTime() {
      return (this.$bus.survey.otherSetting.auditForRedEnvelopesAutoPassTime || 2) * 24
    }
  },
  methods: {
    onAward() {
      const url = this.$bus.getUrl(3)
      console.log(url)
      createPopup(ReceiveReward, {
        isTest: !!this.$bus.params.isTest,
        needAuditFlag: !!this.enableNetManualAudit,
        url
      })
    },
    onPoint() {
      if (this.$bus.currentBrowserInfo.isWeixin) {
        if (!this.$bus.params.accountUserId) {
          Dialog.confirm({
            title: '微信授权提示',
            message: '为保证您能正常兑换商品，请先进行微信授权',
            confirmButtonText: '去授权',
            cancelButtonText: '暂不授权'
          }).then(() => {
            this.$answerUtil.wxAuthorization('2')
          })
          return
        }
      }
      this.onAward()
    },
    onToMiniProgram() {
      this.$answerUtil.getEnv().then(res => {
        if (res.miniprogram) {
          wx.miniProgram.redirectTo({ url: '/pages/index/index?page=personal' })
        } else {
          this.$bus.openLoading()
          getMiniProgramScheme()
            .then(urlScheme => {
              this.$bus.closeLoading()
              if (urlScheme) {
                location.href = urlScheme
              }
            })
            .catch(() => {
              this.$bus.closeLoading()
            })
        }
      })
    },
    toPoint() {
      this.$answerUtil.getEnv().then(res => {
        if (res.miniprogram || this.from === 'app') {
          wx.miniProgram.redirectTo({ url: '/pages/index/index?page=money&openPointsMall=1' })
        } else {
          window.open('https://h5.youzan.com/v2/showcase/homepage?alias=kBIUNsDra6')
        }
      })
      // if((this.from === 'wx' || this.from === 'app') && window.wx) {
      //   wx.miniProgram.redirectTo({ url: '/pages/index/index?page=money&openPointsMall=1' })
      // }else {
      //   window.open('https://h5.youzan.com/v2/showcase/homepage?alias=kBIUNsDra6')
      // }
    }
  }
}
</script>

<style scoped lang="scss">
.survey-point {
  @apply text-theme-black-850 text-small leading-22;
}
.point-btn {
  width: 176px;
  line-height: 32px;
  background: #FF7700;
  font-family: PingFangSC-Regular;
  @apply my-0 mx-auto h-8 mt-2 font-normal text-medium text-white rounded-medium;
}
</style>
